// frontend/src/App.js
import React, { useState, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Sidebar from './components/sidebar';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import PasswordChangeRoute from './components/PasswordChangeRoute';
import { WholesaleCustomersProvider } from './components/wholesale/shared/WholesaleCustomersProvider';

import {
  LoadingFallback,
  coreRoutes,
  dataRoutes,
  bundlesRoutes,
  auditingRoutes,
  purchasingRoutes,
  amazonRoutes,
  wholesaleRoutes,
  inventoryRoutes,
  orderingRoutes,
  logisticsRoutes,
  otherRoutes,
  shopifyRoutes,
  salesRoutes,
  settingsRoutes,
  opsRoutes,
  cashflowRoutes,
  prmRoutes,
  fleetRoutes,
  redirectsRoutes,
} from './routes';

const ChangePassword = lazy(() => import('./components/settings/change-password/ChangePassword'));

function AppLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <>
      <div className={`app-container ${isSidebarOpen ? '' : 'sidebar-hidden'}`}>
        <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
        <header className="app-header">
          <div className="app-title">Fox & Fable Booksellers</div>
        </header>
        <main className="main-content">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {coreRoutes}
              {dataRoutes}
              {bundlesRoutes}
              {auditingRoutes}
              {purchasingRoutes}
              {amazonRoutes}
              {wholesaleRoutes}
              {inventoryRoutes}
              {orderingRoutes}
              {logisticsRoutes}
              {otherRoutes}
              {shopifyRoutes}
              {salesRoutes}
              {settingsRoutes}
              {opsRoutes}
              {cashflowRoutes}
              {prmRoutes}
              {fleetRoutes}
              {redirectsRoutes}
            </Routes>
          </Suspense>
        </main>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/change-password"
          element={
            <PasswordChangeRoute>
              <Suspense fallback={<LoadingFallback />}>
                <ChangePassword />
              </Suspense>
            </PasswordChangeRoute>
          }
        />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <WholesaleCustomersProvider>
                <AppLayout />
              </WholesaleCustomersProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
